import { onDomReady } from '../utils/dom';

function playVideo() {
    const playButtons = document.querySelectorAll('.play-button');

    for (const playButton of playButtons) {
        playButton.addEventListener('click', () => {
            const video = document.getElementById(playButton.getAttribute('aria-controls'));
            playButton.style.display = 'none';
            video.play();
            video.controls = true;
        });
    }
}

onDomReady(() => {
    playVideo();
});
